// MMP1 - FH Salzburg - MultiMediaTechnology
// Tobias Franek <tfranek.mmt-b2018@fh-salzburg.ac.at>

import { observable } from 'mobx';

export class ComponentStore {
   @observable nav: boolean = false;
   @observable chosenOptionId?: number;
   @observable justRemovedComments?: number;
}

export default new ComponentStore();